"use client";

import Link from "next/link";
import Nimage from "./image";
import { useConfig } from "./ConfigProvider";

export default function ServiceDetail({ _data }: any) {
    const config = useConfig();
    const pagedata: any = config?.pages || [];

    const servicePages = pagedata.filter((page: { pid: number }) => page.pid === 23);
    const currentIndex = servicePages.findIndex((page: { uid: number }) => Number(page.uid) === Number(_data.pid));
    const prevPage = currentIndex > 0 ? servicePages[currentIndex - 1] : null;
    const nextPage = currentIndex < servicePages.length - 1 ? servicePages[currentIndex + 1] : null;

    return (
        <>
            {prevPage ? (
                <Link href={`${prevPage.slug}`} className="cir-butn line-butn icon-200 d-inline-flex me-2">
                    <div className="cont"> <span className="txt fsz-20">{_data?.previousbuttontext1746446244} </span> {_data?.previousarrowimage1746446272?.length > 0 ? _data?.previousarrowimage1746446272.map((immg: any, index: any) => (
                        <Nimage key={_data?.uid + immg?.url + index + 'previousarrowimage1746446272'} immg={immg} data={_data} className="arrow" />
                    )) : null} </div>
                </Link>
            )
                : <button className="cir-butn line-butn icon-200 d-inline-flex me-2 opacity-50 cursor-not-allowed" disabled><div className="cont"> <span className="txt fsz-20">{_data?.previousbuttontext1746446244} </span> {_data?.previousarrowimage1746446272?.length > 0 ? _data?.previousarrowimage1746446272.map((immg: any, index: any) => (
                    <Nimage key={_data?.uid + immg?.url + index + 'previousarrowimage1746446272'} immg={immg} data={_data} className="arrow" />
                )) : null} </div>
                </button>
            }
            {nextPage ? (
                <Link href={`${nextPage.slug}`} className="cir-butn icon-200 d-inline-flex">
                    <div className="cont"> <span className="txt fsz-20"> {_data?.nextbuttontext1746446314} </span>  {_data?.nextarrowimage1746446325?.length > 0 ? _data?.nextarrowimage1746446325.map((immg: any, index: any) => (
                        <Nimage key={_data?.uid + immg?.url + index + 'nextarrowimage1746446325'} immg={immg} data={_data} className="arrow" />
                    )) : null} </div>
                </Link>
            )
                : <button className="cir-butn icon-200 d-inline-flex opacity-50 cursor-not-allowed" disabled><div className="cont"> <span className="txt fsz-20">{_data?.nextbuttontext1746446314} </span> {_data?.nextarrowimage1746446325?.length > 0 ? _data?.nextarrowimage1746446325.map((immg: any, index: any) => (
                    <Nimage key={_data?.uid + immg?.url + index + 'nextarrowimage1746446325'} immg={immg} data={_data} className="arrow" />
                )) : null} </div>
                </button>
            }
        </>
    )
}